import { useEffect, useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { trpc, useMutation } from 'client/lib/trpc';
import { useUser } from 'client/lib/User';
import { QuickLaunchDialog } from 'client/components/Dialog/QuickLaunchDialog';

// Accept anonymous trial token and redirect to launch page
export const AnonymousTrialLoginPage = () => {
  const { token } = useParams();
  const { updateSession } = useUser();
  const [error, setError] = useState<string | null>(null);
  const navigate = useNavigate();
  const effectRan = useRef(false);

  const loginMutation = useMutation(trpc.account.anonymousTrialLogin, {
    onSuccess: async (data) => {
      if (data.status == 'ok') {
        await updateSession();
        navigate('/launch', { replace: true });
      } else {
        setError(data.status);
      }
    },
  });

  useEffect(() => {
    if (effectRan.current) return;
    if (!token) return;
    if (!loginMutation.isLoading && !loginMutation.data) {
      loginMutation.mutate({ token: token as string });
    }

    return () => {
      effectRan.current = true;
    };
  }, [token]);

  return <QuickLaunchDialog data={null} error={error} hideBackdrop />;
};
